import React from "react"
import { Container, Circle } from "./styles"

const LoadingSpinner = ({ primary, grey }) => (
  <Container primary={primary} grey={grey}>
    <Circle></Circle>
    <Circle></Circle>
    <Circle></Circle>
    <Circle></Circle>
    <Circle></Circle>
    <Circle></Circle>
    <Circle></Circle>
    <Circle></Circle>
    <Circle></Circle>
    <Circle></Circle>
    <Circle></Circle>
    <Circle></Circle>
  </Container>
)

export default LoadingSpinner
